export default __webpack_public_path__ + "static/media/limited-purpose-fsa-guide.ed632768.svg";